"use client"

import { useInstallAnalytics } from '@/hooks/use-install-analytics'

export function InstallAnalytics() {
  useInstallAnalytics()
  return null
}